import { Injectable } from '@angular/core';
import { CoolHttp } from '@angular-cool/http';
import { CampaignSessionIdentifiers, CampaignSessionSectionDTO, CampaignSessionSectionId } from '../../../../../common/dto/campaigns.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';
import { Observable, Subject } from 'rxjs';
import { CacheState, CacheStateUpdater } from '@coool/cachestate';
import { filterDefined } from '../utils/observable.utils';
import { FileUploadRequestUtils } from '../utils/file-upload-request.utils';

const campaignSessionSectionsCacheUpdater = new Subject<string | void>();

@Injectable()
export class CampaignSessionSectionsService {
  constructor(private _http: CoolHttp) {}

  @CacheState({
    maxAgeMS: 5 * MINUTE_IN_MILLISECONDS,
    cacheKey: {
      generator: args => `campaign-session-sections_${args[0].campaignSessionId}`,
    },
    updatedObservable: campaignSessionSectionsCacheUpdater.pipe(filterDefined()),
  })
  public getCampaignSessionSectionsCACHED(campaignSessionIdentifier: CampaignSessionIdentifiers): Observable<CampaignSessionSectionDTO[]> {
    return this._http.getObservable(
      ServerUrls.Campaigns.children.Sessions.children.Sections.children.Get.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignSessionIdentifier.campaignId,
        [ServerUrls.Campaigns.children.Sessions.children.Sections.params.campaignSessionId]: campaignSessionIdentifier.campaignSessionId,
      }),
    );
  }

  @CacheStateUpdater({
    cacheKeyGenerator: args => `campaign-session-sections_${args[0].campaignSessionId}`,
    updatedNotifier: campaignSessionSectionsCacheUpdater,
  })
  public async upsertCampaignSessionSectionAsync(
    campaignSessionIdentifier: CampaignSessionIdentifiers,
    section: CampaignSessionSectionDTO,
  ): Promise<CampaignSessionSectionDTO> {
    const formData = FileUploadRequestUtils.createRequestForm('section', section, [
      {
        name: 'mapImage',
        resolver: _ => _.mapImage,
      },
    ]);

    return await this._http.postAsync(
      ServerUrls.Campaigns.children.Sessions.children.Sections.children.Upsert.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignSessionIdentifier.campaignId,
        [ServerUrls.Campaigns.children.Sessions.children.Sections.params.campaignSessionId]: campaignSessionIdentifier.campaignSessionId,
      }),
      formData,
    );
  }

  @CacheStateUpdater({
    cacheKeyGenerator: args => `campaign-session-sections_${args[0].campaignSessionId}`,
    updatedNotifier: campaignSessionSectionsCacheUpdater,
  })
  public async removeCampaignSessionSectionAsync(
    campaignSessionIdentifier: CampaignSessionIdentifiers,
    sectionId: CampaignSessionSectionId,
  ) {
    return await this._http.deleteAsync(
      ServerUrls.Campaigns.children.Sessions.children.Sections.children.Delete.getAbsoluteUrlWithParams({
        [ServerUrls.Campaigns.children.Sessions.params.campaignId]: campaignSessionIdentifier.campaignId,
        [ServerUrls.Campaigns.children.Sessions.children.Sections.params.campaignSessionId]: campaignSessionIdentifier.campaignSessionId,
        [ServerUrls.Campaigns.children.Sessions.children.Sections.children.Delete.params.campaignSessionSectionId]: sectionId,
      }),
    );
  }
}
